import { useSpring, animated } from "@react-spring/web"
import { useState } from "react";
import CustomInput from "../../components/custom-input"

const Login = ({ onSwitch, fn, error }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const buttonSpring = useSpring({
        opacity: email && password ? 1 : 0.3
    })

    return (
        <div
            className="space-y-10 p-3 md:p-10 rounded-md text-white max-w-3xl"
        >
            <div
                className="text-white"
            >
                <p
                    className="text-lg font-light"
                >
                    Log ind på MitVærksted
                </p>
                <p
                    className="text-2xl md:text-3xl font-light mb-3"
                >
                    Udnyt alle fordelene med MitVærksted
                </p>
                <p
                    className="font-extralight text-sm"
                >
                    Du kan færdiggøre tilbudsflowet endnu hurtigere, hvis vi henter dine info fra tidligere besøg.
                </p>
            </div>
            <div
                className="max-w-md space-y-4"
            >
                <CustomInput
                    focusColor="white"
                    value={email}
                    onChange={e => {
                        setEmail(e.target.value)
                    }}
                    labelText="Email"
                    placeholder="jensen@mail.dk"
                />
                <CustomInput
                    focusColor="white"
                    type="password"
                    value={password}
                    onChange={e => {
                        setPassword(e.target.value)
                    }}
                    labelText="Adgangskode"
                    placeholder="******"
                />
                <div
                    className="flex space-x-3"
                >
                    <animated.button
                        style={buttonSpring}
                        className="bg-skgRed p-3 rounded-md text-white flex-1"
                        onClick={() => fn(email, password)}
                    >
                        Login
                    </animated.button>
                    <button
                        className="flex-1"
                        onClick={onSwitch}
                    >
                        Opret bruger
                    </button>
                </div>
                <div
                    className="text-sm"
                >
                    {error}
                </div>
            </div>
        </div>
    )
}

export default Login;